/* ===== Cenzio — yapiskan seritte fiyat ve varyant metni =====
   Dawn varyant degisince fiyat kutusunu BASTAN olusturuyor; eski dugume
   baglanan izleyici kopuyor. Bu yuzden her tazelemede yeniden sorgulariz.
   ============================================================ */
(function () {
  'use strict';

  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  function stickyPrice() {
    var out = document.querySelector('[data-cz-sticky-price]');
    if (!out) return;
    var live = document.querySelector('.product__info-container .price');
    if (!live) return;
    var onSale = live.classList.contains('price--on-sale');
    var el = onSale
      ? live.querySelector('.price__sale .price-item--sale')
      : live.querySelector('.price__regular .price-item--regular');
    if (!el) el = live.querySelector('.price-item');
    var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    if (t) out.textContent = t;
  }

  function stickyVariant() {
    var out = document.querySelector('[data-cz-sticky-variant]');
    if (!out) return;
    var parts = [];
    document.querySelectorAll('.product-form__input--pill').forEach(function (f) {
      if (f.classList.contains('cz-hide-opt')) return;
      var c = f.querySelector('input[type="radio"]:checked');
      if (!c) return;
      var l = f.querySelector('label[for="' + c.id + '"]');
      var tn = l ? firstTextNode(l) : null;
      var t = tn ? tn.textContent.trim().replace(/\s*\([^)]*\)\s*$/, '') : '';
      if (t) parts.push(t);
    });
    out.textContent = parts.join(' · ');
  }

  function sync() { stickyPrice(); stickyVariant(); }

  function init() {
    sync();
    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(sync, 80);
      }).observe(info, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product-form__input')) {
        setTimeout(sync, 90);
        setTimeout(sync, 400);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
